import type { Definition } from '~/types'
import mapperIcon from '../utils/mappers/mapper-icon'
import { mapperFormThankYou } from '../pages/page-contact-detail/mapper-form-thank-you'

export const PageContact: Definition = {
  contentType: 'PageContact',
  fields: [
    {
      id: 'pointsOfContact',
      name: 'Points of contact',
      type: 'Array',
      subType: 'ModuleMediaCard'
    },
    {
      id: 'complaintLink',
      name: 'Complaint Link',
      type: 'ModuleNavigationLink'
    },
    {
      id: 'addressField1',
      name: 'Address Field 1',
      type: 'RichText'
    },
    {
      id: 'addressField2',
      name: 'Address Field 2',
      type: 'RichText'
    },
    {
      id: 'officesLink',
      name: 'Offices Link',
      type: 'ModuleNavigationLink'
    }
  ]
}

export const PageContactDetail: Definition = {
  contentType: 'PageContactDetail',
  fields: [
    {
      id: 'icon',
      name: 'Icon',
      type: 'Symbol',
      customMapper: mapperIcon
    },
    {
      id: 'description',
      name: 'Description',
      type: 'RichText'
    },
    {
      id: 'informationLink',
      name: 'Information Link',
      type: 'ModuleNavigationLink'
    },
    {
      id: 'formTitle',
      name: 'Form title',
      type: 'Text'
    },
    {
      id: 'formMessageFieldLabel',
      name: 'Form message field label',
      type: 'Symbol'
    },
    {
      id: 'formMessageFieldInfo',
      name: 'Form message field info',
      type: 'Symbol'
    },
    {
      id: 'formId',
      name: 'Form id',
      type: 'Symbol'
    },
    {
      id: 'stepsFormEnabled',
      name: 'Steps Form Enabled',
      type: 'Boolean'
    },
    {
      id: 'pointsOfContact',
      name: 'Points of contact',
      type: 'Array',
      subType: 'ModuleMediaCard'
    },
    {
      id: 'formThankYouPage',
      name: 'Form thank you page',
      type: 'PageContactThankYou',
      customMapper: mapperFormThankYou
    }
  ]
}

export const PageContactThankYou: Definition = {
  contentType: 'PageContactThankYou',
  fields: [
    {
      id: 'description',
      name: 'Description',
      type: 'RichText'
    },
    {
      id: 'pointsOfContact',
      name: 'Points of contact',
      type: 'Array',
      subType: 'ModuleMediaCard'
    }
  ]
}

export default {
  PageContact,
  PageContactDetail,
  PageContactThankYou
}
